import {Button} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../i18n/translations';
import AddIcon from '@mui/icons-material/Add';
import {useObserveViewport} from '../../../../hooks';
import {Tooltip} from '../../../tooltip/tooltip';

export type CareServicesAddButtonProps = {
  onClick?: (evt: React.MouseEvent) => void;
  disabled?: boolean;
};

export function CareServiceAddButton(props: CareServicesAddButtonProps) {
  const {t} = useTranslation();
  const {isRunningCloseToMobile: isGettingCloseToMobile} = useObserveViewport();

  return (
    <Tooltip.NotAllowedIf
      condition={props.disabled}
      title={t(translations.care_services.header.add_button_disabled_tooltip)}
    >
      <Button
        variant="inverted"
        size="large"
        onClick={props.onClick}
        startIcon={<AddIcon />}
        sx={{
          width: 'auto',
          py: '8px',
          textTransform: 'uppercase',
          '& .MuiButton-startIcon': {
            margin: isGettingCloseToMobile ? 0 : undefined,
          },
        }}
        disabled={props.disabled}
      >
        {!isGettingCloseToMobile && t(translations.planner.header.add)}
      </Button>
    </Tooltip.NotAllowedIf>
  );
}
